import React from "react";
import { Link } from "react-router-dom";
import PublicNav from "../components/PublicNav";
import Footer from "../components/Footer";

export default function PercheDiventarePartner() {
  return (
    <div className="paper-bg" data-testid="perche-partner-page">
      <PublicNav />

      {/* HERO */}
      <section className="max-w-[1240px] mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-16">
        <div className="label-uppercase mb-6">Perché diventare Partner</div>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight max-w-5xl">
          Oggi l'esclusiva la strappi.<br className="hidden md:block" /> Con il Protocollo, arriva da sé.
        </h1>
      </section>

      {/* BLOCCO INTRODUTTIVO */}
      <section className="border-t border-[#E6E4E0]">
        <div className="max-w-[880px] mx-auto px-6 md:px-10 py-20">
          <p className="font-serif text-2xl md:text-[28px] leading-[1.55] text-[#3A3D42]">
            Questo è il punto che cambia tutto. Oggi convincere un venditore a darti l'esclusiva
            è una battaglia: insisti, spieghi, negozi — e spesso ottieni un incarico debole,
            condiviso, revocabile. Con il Protocollo l'esclusiva smette di essere una tua
            richiesta e diventa la condizione naturale del metodo. La verifica richiede accesso
            completo all'immobile, agli atti, agli impianti: non si fa a metà, non si fa in
            condivisione. Il venditore non ti concede l'esclusiva come favore — te la dà perché
            è l'unico modo per entrare nel Protocollo.
          </p>
          <p className="font-serif text-2xl md:text-[28px] leading-[1.55] text-[#7D2E3F] mt-8">
            Il mandato forte non lo chiedi più. Lo spieghi.
          </p>
        </div>
      </section>

      {/* SEZIONE BOLLINO — Chef della zona */}
      <section className="border-t border-[#E6E4E0] paper-alt-bg">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 py-20 md:py-24 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="md:col-span-4 flex justify-center md:justify-start">
            <img
              src="/brand/bollino-512.png"
              alt="Bollino Pronto alla Vendita by RX CASA"
              className="w-52 h-52 sm:w-60 sm:h-60 md:w-72 md:h-72"
              data-testid="partner-bollino"
            />
          </div>
          <div className="md:col-span-8">
            <div className="label-uppercase text-[#7D2E3F] mb-3">La stella della categoria</div>
            <h2 className="font-serif text-3xl md:text-4xl leading-tight text-[#3A3D42]">
              Non un'agenzia in più.<br className="hidden md:block" /> Lo chef della zona.
            </h2>
            <p className="text-base md:text-lg text-[#5C5657] mt-6 leading-relaxed">
              Oggi quasi tutte le agenzie competono sulla stessa cosa: valutazione gratis,
              provvigione più bassa, gli stessi portali. È la guerra del prezzo. Come esce un
              ristorante da quella guerra? Conquistando la stella. Non cambia il cibo:
              dimostra uno standard di disciplina non negoziabile.
            </p>
            <p className="text-base md:text-lg text-[#5C5657] mt-4 leading-relaxed">
              Nell'immobiliare, quella stella è <span className="text-[#3A3D42]">Pronto alla Vendita</span> — la categoria che
              distingue un immobile verificato e valorizzato prima del mercato da uno semplicemente
              in vendita. RX CASA è la Guida che la assegna: lo standard terzo, che vale proprio
              perché non vende case e non compete con te. E tu sei lo chef. L'unico della tua zona
              capace di portare i tuoi immobili a meritarla.
            </p>
            <p className="text-base md:text-lg text-[#3A3D42] mt-4 leading-relaxed">
              Non è un logo che compri: è una categoria che i tuoi immobili conquistano — e che
              ti distingue da chi sta ancora facendo la guerra del prezzo.
            </p>
          </div>
        </div>
      </section>

      {/* COSA CAMBIA — 3 blocchi */}
      <section className="border-t border-[#E6E4E0]">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 py-20 md:py-24">
          <div className="label-uppercase mb-3">In pratica</div>
          <h2 className="font-serif text-3xl md:text-4xl leading-tight text-[#3A3D42] max-w-3xl">
            Cosa cambia, in concreto.
          </h2>
          <div className="grid md:grid-cols-3 gap-8 md:gap-10 mt-14">
            {[
              { n: "01", t: "La trattativa è protetta.", d: "Le criticità emerse a trattativa avviata erano la tua vulnerabilità. Con il Protocollo sono note prima, dichiarate nel Fascicolo, integrate nel prezzo. L'acquirente non ha nulla da scoprire — niente da usare come leva di ribasso. Il prezzo si difende con i documenti, non con le parole." },
              { n: "02", t: "Il mandato non si cambia.", d: "Il venditore che vuole cambiare agenzia perde il Fascicolo. Dovrebbe ricominciare: nuovo sopralluogo, nuove verifiche, nuovo pagamento. Non è una clausola. È una struttura che rende il cambio di mandato costoso e irrazionale." },
              { n: "03", t: "I lead arrivano a te.", d: "La Galleria pubblica raccoglie gli immobili Pronto alla Vendita. Il venditore che vuole il Bollino cerca chi può darglielo, e viene indirizzato all'Agenzia Partner della sua zona. Non vai più a caccia di mandati: sono i mandati a cercare te — già informati, già motivati." },
            ].map((b) => (
              <div key={b.n} className="border-l-2 border-[#7D2E3F] pl-6" data-testid={`partner-block-${b.n}`}>
                <div className="label-uppercase text-[#7D2E3F] mb-3">{b.n}</div>
                <h3 className="font-serif text-2xl text-[#3A3D42] leading-tight">{b.t}</h3>
                <p className="text-sm md:text-base text-[#5C5657] mt-4 leading-relaxed">{b.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PARTNER FONDATORE */}
      <section className="border-t border-[#E6E4E0] bg-[#22242A] text-white" data-testid="partner-fondatore-section">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10 py-20 md:py-24">
          <div className="label-uppercase text-[#F2C7CE] mb-3" data-testid="fondatore-eyebrow">Chi entra adesso</div>
          <h2 className="font-serif text-3xl md:text-4xl leading-tight max-w-3xl">
            Partner Fondatore.
          </h2>
          <p className="text-base md:text-lg text-white/80 mt-6 max-w-3xl leading-relaxed">
            Le prime agenzie di ogni provincia hanno uno status specifico.
          </p>

          <div className="grid md:grid-cols-3 gap-8 md:gap-12 mt-14">
            {[
              { t: "Priorità territoriale", d: "Precedenza nella ricezione dei lead del territorio." },
              { t: "Diritto di prelazione", d: "Sull'esclusiva della propria provincia, quando verrà introdotta." },
              { t: "Vantaggio reputazionale", d: "Il capitale che si accumula solo entrando per primi." },
            ].map((b, i) => (
              <div key={i} className="border-t border-white/30 pt-6" data-testid={`fondatore-vantaggio-${i+1}`}>
                <div className="label-uppercase text-[#F2C7CE] mb-2" data-testid={`fondatore-vantaggio-num-${i+1}`}>0{i+1}</div>
                <h3 className="font-serif text-xl md:text-2xl">{b.t}</h3>
                <p className="text-sm md:text-base text-white/80 mt-3 leading-relaxed">{b.d}</p>
              </div>
            ))}
          </div>

          <p className="text-base md:text-lg text-white/90 mt-14 max-w-3xl leading-relaxed border-t border-white/30 pt-8">
            Massimo <span className="text-white font-semibold">2–3 Partner Fondatori per provincia</span>.
            Il valore è cumulativo: chi entra presto capitalizza ogni stadio. Chi aspetta trova la
            posizione già occupata.
          </p>
        </div>
      </section>

      {/* CHIUSURA */}
      <section className="border-t border-[#E6E4E0]">
        <div className="max-w-[880px] mx-auto px-6 md:px-10 py-20 md:py-24">
          <div className="label-uppercase mb-3">La decisione</div>
          <h2 className="font-serif text-4xl md:text-5xl leading-tight text-[#3A3D42]">
            Una scelta sola.
          </h2>
          <p className="text-base md:text-lg text-[#5C5657] mt-8 leading-relaxed">
            Continuare come hai sempre lavorato — gestire le criticità quando emergono, difendere
            la provvigione, inseguire i mandati. Oppure strutturare il processo, proteggere la
            trattativa, entrare in una categoria che i competitor non possono comprare domani
            mattina.
          </p>
          <p className="font-serif text-2xl md:text-3xl text-[#3A3D42] mt-10 leading-tight">
            Il mercato cambia. <span className="text-[#7D2E3F]">La domanda è chi arriva prima.</span>
          </p>

          <div className="mt-12">
            <Link
              to="/form?candidatura=1"
              data-testid="partner-cta"
              className="btn-primary inline-block"
            >
              Candida la tua agenzia
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
